import { fromJS } from 'immutable';

import {
  BENCHMARK_CONFIGURATION,
  TIME_SELECTOR_DATE_CHANGED,
} from "./constants";

const initialState = fromJS({
  time_selector_date_change: {},
});

function appReducer(state = initialState, action) {
  switch(action.type) {
    case TIME_SELECTOR_DATE_CHANGED:
      return state.set('time_selector_date_change', fromJS(action.change));
    default:
      return state;
  }
}

const benchmarkInitialState = fromJS({
  portfolio_id: undefined,
  modal_opened: false,
  configuration_required: false
});

export function benchmarkConfigurationReducer(state=benchmarkInitialState, action) {
  switch(action.type) {
    case BENCHMARK_CONFIGURATION:
      const configuration_required = typeof action.configuration_required === 'boolean' ?
        action.configuration_required : state.get('configuration_required')
      return fromJS({
        portfolio_id: action.portfolio_id,
        modal_opened: action.modal_opened,
        configuration_required
      });
    default:
      return state;
  }
}

export default appReducer;